import { BaseFetchOptionsFormatter } from "../../../base";
export class MarketsBffOptionsFormatter extends BaseFetchOptionsFormatter {
    constructor(options) {
        super(options);
    }
    get options() {
        return {};
    }
}
//# sourceMappingURL=MarketsBffOptionsFormatter.js.map